<div class="row row-cols-1 row-cols-md-3">
    <div class="col mb-4">
        <div class="card h-100 shadow-sm">
            <div class="card-img-top text-center pt-3">
                <i class="bi-building" style="font-size: 2.5rem;"></i>
            </div>
            <div class="card-body">
                <h4 class="card-title d-flex justify-content-between align-items-center">
                    <div class="">
                        <i class="fas fa-info-circle"></i>
                        <span class="ml-1">
                            회사관리
                        </span>
                    </div>
                </h4>
                <div class="card-text">
                    <div class="mt-2">
                        공단 운행기록을 제출하기 위한 사업자번호,법인등록번호,업체코드 등을 관리
                    </div>
                    <div class="mt-2">
                        ※ 법인이 여러 개 인 경우 하위 회사를 법인별로 생성하고 차량,사용자,운전자를 각 법인에 맞게 지정하여 사용할 수 있습니다
                    </div>
                </div>
                <div class="card-text mt-3">
                    <small class="text-muted">
                        자세한 사항은 서포트팀에게 문의하시기 바랍니다
                    </small>
                </div>
                <div class="card-text mt-5 text-center">
                    <button type="button" class="btn btn-sm btn-outline-secondary btn-rounded"
                        [routerLink]="['/','dtg','manage','company','main']">
                        <i class="fas fa-arrow-circle-right"></i>
                        <span class="ml-1">
                            해당 메뉴로 이동
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="col mb-4">
        <div class="card h-100 shadow-sm">
            <div class="card-img-top text-center pt-3">
                <i class="bi bi-diagram-3" style="font-size: 2.5rem;"></i>
            </div>
            <div class="card-body">
                <h4 class="card-title d-flex justify-content-between align-items-center">
                    <div class="">
                        <i class="fas fa-info-circle"></i>
                        <span class="ml-1">
                            그룹관리
                        </span>
                    </div>
                </h4>
                <div class="card-text">
                    <div class="mt-2">
                        회사 내 그룹 조직 관리
                    </div>
                    <div class="mt-2">
                        ※ 조직별 차량 관리가 필요 한 경우 그룹을 만들고 차량,사용자,운전자를 각 그룹에 맞게 지정하여 사용할 수 있습니다
                    </div>
                </div>
                <div class="card-text mt-3">
                    <small class="text-muted">
                        자세한 사항은 서포트팀에게 문의하시기 바랍니다
                    </small>
                </div>
                <div class="card-text mt-5 text-center">
                    <button type="button" class="btn btn-sm btn-outline-secondary btn-rounded"
                        [routerLink]="['/','dtg','manage','team','main']">
                        <i class="fas fa-arrow-circle-right"></i>
                        <span class="ml-1">
                            해당 메뉴로 이동
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="col mb-4">
        <div class="card h-100 shadow-sm">
            <div class="card-img-top text-center pt-3">
                <i class="bi bi-truck" style="font-size: 2.5rem;"></i>
            </div>
            <div class="card-body">
                <h4 class="card-title d-flex justify-content-between align-items-center">
                    <div class="">
                        <i class="fas fa-info-circle"></i>
                        <span class="ml-1">
                            차량관리
                        </span>
                    </div>
                </h4>
                <div class="card-text">
                    <div class="mt-2">
                        소속차량관리
                        <ul class="mb-0">
                            <li>
                                회사 소속 차량 관리
                            </li>
                            <li>
                                화주사가 본 서비스에 가입되어 있을 경우에 공급승인을 통해 관제정보 제공이 가능합니다
                            </li>
                        </ul>
                    </div>
                    <div class="mt-2">
                        공급차량관리
                        <ul class="mb-0">
                            <li>
                                운수사로 부터 공급 받는 차량의 목록을 확인 할 수 있습니다(서비스 가입 必)
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="card-text mt-3">
                    <small class="text-muted">
                        자세한 사항은 서포트팀에게 문의하시기 바랍니다
                    </small>
                </div>
                <div class="card-text mt-5 text-center">
                    <button type="button" class="btn btn-sm btn-outline-secondary btn-rounded"
                        [routerLink]="['/','dtg','manage','car','main']">
                        <i class="fas fa-arrow-circle-right"></i>
                        <span class="ml-1">
                            해당 메뉴로 이동
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="col mb-4">
        <div class="card h-100 shadow-sm">
            <div class="card-img-top text-center pt-3">
                <!-- <i class="bi bi-person-circle text-white" style="font-size: 2.5rem;"></i> -->
                <i class="bi bi-people" style="font-size: 2.5rem;"></i>
            </div>
            <div class="card-body">
                <h4 class="card-title d-flex justify-content-between align-items-center">
                    <div class="">
                        <i class="fas fa-info-circle"></i>
                        <span class="ml-1">
                            사용자관리
                        </span>
                    </div>
                </h4>
                <div class="card-text">
                    <div class="mt-2">
                        DTG관제 사이트에 접속, 운영할 수 있는 계정관리
                    </div>
                    <div class="mt-2">
                        ※ 권한
                        <ul class="mb-0">
                            <li>
                                관리자: 회사의 대표 계정으로 모든 권한
                            </li>
                            <li>
                                운영자: 운영에 필요한 권한(일부 권한 제외)
                            </li>
                            <li>
                                운전자: 교통안전공단 제출용 정보 (배차,휴식시간에 사용됩니다)
                            </li>
                            <li>
                                게스트: 간단한 차량 관제를 볼 수 있는 권한
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="card-text mt-3">
                    <small class="text-muted">
                        자세한 사항은 서포트팀에게 문의하시기 바랍니다
                    </small>
                </div>
                <div class="card-text mt-5 text-center">
                    <button type="button" class="btn btn-sm btn-outline-secondary btn-rounded"
                        [routerLink]="['/','dtg','manage','user','main']">
                        <i class="fas fa-arrow-circle-right"></i>
                        <span class="ml-1">
                            해당 메뉴로 이동
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="col mb-4">
        <div class="card h-100 shadow-sm">
            <div class="card-img-top text-center pt-3">
                <i class="bi bi-person-badge" style="font-size: 2.5rem;"></i>
            </div>
            <div class="card-body">
                <h4 class="card-title d-flex justify-content-between align-items-center">
                    <div class="">
                        <i class="fas fa-info-circle"></i>
                        <span class="ml-1">
                            운전자관리
                        </span>
                    </div>
                </h4>
                <div class="card-text">
                    <div class="mt-2">
                        운수종사자 ID, 입사일자 등 운수종사자의 정보를 저장, 관리
                    </div>
                    <div class="mt-2">
                        ※ 교통안전공단에 제출하기 위한 정보로 배차,휴식시간에 사용됩니다
                    </div>
                </div>
                <div class="card-text mt-3">
                    <small class="text-muted">
                        자세한 사항은 서포트팀에게 문의하시기 바랍니다
                    </small>
                </div>
                <div class="card-text mt-5 text-center">
                    <button type="button" class="btn btn-sm btn-outline-secondary btn-rounded"
                        [routerLink]="['/','dtg','manage','driver','main']">
                        <i class="fas fa-arrow-circle-right"></i>
                        <span class="ml-1">
                            해당 메뉴로 이동
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="col mb-4">
        <div class="card h-100 shadow-sm">
            <div class="card-img-top text-center pt-3">
                <!-- <i class="bi bi-card-checklist text-white" style="font-size: 2.5rem;"></i> -->
                <i class="bi bi-stopwatch" style="font-size: 2.5rem;"></i>
            </div>
            <div class="card-body">
                <h4 class="card-title d-flex justify-content-between align-items-center">
                    <div class="">
                        <i class="fas fa-info-circle"></i>
                        <span class="ml-1">
                            배차관리
                        </span>
                    </div>
                </h4>
                <div class="card-text">
                    <div class="mt-2">
                        휴식시간 보장내역 통보서 산출을 위한 배차 정보 관리
                    </div>
                </div>
                <div class="card-text mt-3">
                    <small class="text-muted">
                        자세한 사항은 서포트팀에게 문의하시기 바랍니다
                    </small>
                </div>
                <div class="card-text mt-5 text-center">
                    <button type="button" class="btn btn-sm btn-outline-secondary btn-rounded"
                        [routerLink]="['/','dtg','manage','schedule','drive','main']">
                        <i class="fas fa-arrow-circle-right"></i>
                        <span class="ml-1">
                            해당 메뉴로 이동
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="col mb-4">
        <div class="card h-100 shadow-sm">
            <div class="card-img-top text-center pt-3">
                <!-- <i class="bi bi-box-arrow-in-right text-white" style="font-size: 2.5rem;"></i> -->
                <!-- <i class="bi bi-cone-striped text-white" style="font-size: 2.5rem;"></i> -->
                <i class="bi bi-door-open" style="font-size: 2.5rem;"></i>
                <!-- <i class="bi bi-geo-alt text-white" style="font-size: 2.5rem;"></i> -->
            </div>
            <div class="card-body">
                <h4 class="card-title d-flex justify-content-between align-items-center">
                    <div class="">
                        <i class="fas fa-info-circle"></i>
                        <span class="ml-1">
                            지오펜스관리
                        </span>
                    </div>
                </h4>
                <div class="card-text">
                    <div class="mt-2">
                        특정 지역에 차량의 출입기록을 관리
                    </div>
                    <div class="mt-2">
                        원형,사각형,다각형으로 관리 지역을 설정 할 수 있습니다
                    </div>
                </div>
                <div class="card-text mt-3">
                    <small class="text-muted">
                        자세한 사항은 서포트팀에게 문의하시기 바랍니다
                    </small>
                </div>
                <div class="card-text mt-5 text-center">
                    <button type="button" class="btn btn-sm btn-outline-secondary btn-rounded"
                        [routerLink]="['/','dtg','manage','geofence','conf','main']">
                        <i class="fas fa-arrow-circle-right"></i>
                        <span class="ml-1">
                            해당 메뉴로 이동
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>